// @core/api/endpoints/localization/update_glossary_entry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GlossaryEntryResponse,
  UpdateGlossaryEntryRequest,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Update glossary entry
 * Updates a glossary entry's term, definition, or translations.
 */
export async function UpdateGlossaryEntry(
  entry_id: string,
  data: UpdateGlossaryEntryRequest,
  options?: RequestOptions
): Promise<GlossaryEntryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/glossary/:entry_id`;
  requestPath = requestPath.replace(':entry_id', encodeURIComponent(entry_id));
  const requestOptions = options;
  return client.put<GlossaryEntryResponse>(requestPath, data, requestOptions);
}
